import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {PageTitle} from '../../../../_metronic/layout/core'
import {InputDefault, ModalDefault, TableDefault} from '../../../components/ui'
import {getConfigs} from '../../../modules/services/configs.service'
import {deleteProductsById, getListProduct} from '../../../modules/services/product.service'
import {getBreadCrumbs} from '../breadcrumbs'

const ProductPage = () => {
  const queryClient = useQueryClient()
  const headFields = ['SKU', 'Product', 'Point (%)', 'Detail Product']
  const bodyFields = ['attributes.sku', 'attributes.name', 'attributes.percent', 'attributes.product_detail']
  const [filter, setFilter] = useState('')
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const {data, isLoading} = useQuery(['getProductList', search, filter, page], async () =>
    getListProduct(search, filter)
  )
  const datas: any = data?.data ?? []
  const pageCount = data?.meta?.pagination.pageCount
  const {data: datass} = useQuery(['getConfigs'], async () => await getConfigs())

  const handleDelete = (id: any) => {
    mutate(id)
  }

  const {mutate, isLoading: loading} = useMutation((id) => deleteProductsById(id), {
    onSuccess: async () => {
      // buttonRef.current?.click()
      toast.success('Delete Data Succes')
      await queryClient.invalidateQueries('getProductList')
    },
    onError(error: any) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }
  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Product & Point Mapping</p>
          </div>
          <div className='me-6 d-flex flex-column align-items-end gap-4'>
            <div className='d-flex flex-row gap-4'>
              {/* <button
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#import-member'
              >
                Import
              </button> */}
              <Link to={'/productcreate'}>
                <button className='btn btn-primary' data-bs-target='#add-edit-member'>
                  Add
                </button>
              </Link>
            </div>
            <div className='d-flex flex-row gap-4'>
              <InputDefault
                placeholder='Search'
                left={<i className='bi bi-search' />}
                onChange={(e: any) => setSearch(e.target.value)}
              />
              {/* <DropdownDefault
                type='Filter'
                list={members.filters}
                dataState={[filter, setFilter]}
              /> */}
            </div>
          </div>
        </div>
        {!isLoading && (
          <TableDefault
            head={headFields}
            body={bodyFields}
            data={datas}
            href={'product'}
            handleDelete={handleDelete}
            showEdit={true}
            allPaginate={pageCount}
            page={page}
            setsPage={setPage}
            nextPage={nextPage}
            prevPage={prevPage}
            loadings={loading}
            texts={'Apakah anda yakin ingin menghapus product ini'}
          />
        )}
        <ModalDefault id='import-member' title='Import Space'>
          <div className='d-flex flex-column align-items-center gap-4'>
            <label htmlFor='import-upload-input'>
              <button id='import-upload-input' className='btn btn-primary'>
                <i className='bi bi-file-earmark-arrow-up' />
                Upload File
              </button>
              <input type='file' id='import-upload-input' className='d-none' />
            </label>
          </div>
        </ModalDefault>
      </div>
    </>
  )
}

const ProductWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('loyalty-point/product')}>
        {intl.formatMessage({id: 'MENU.PRODUCT'})}
      </PageTitle>
      <ProductPage />
    </>
  )
}

export default ProductWrapper
